import actionTypes from '../actionTypes'

const iVideoCreationOeqActions = {
	createNewOeqActivitySuccess: (activityUid, breakpointActivityUid) => ({
		type: actionTypes.INTERACTIVE_VIDEO_CREATION_OEQ_CREATE_SUCCESS,
		activityUid,
		breakpointActivityUid,
	}),
	createNewOeqActivityError: activity => ({
		type: actionTypes.INTERACTIVE_VIDEO_CREATION_OEQ_CREATE_ERROR,
		activity,
	}),
	saveOEQ: () => ({
		type: actionTypes.INTERACTIVE_VIDEO_CREATION_OEQ_SAVE,
	}),
	saveOEQError: error => ({
		type: actionTypes.INTERACTIVE_VIDEO_CREATION_OEQ_SAVE_ERROR,
		error,
	}),
	saveOEQSuccess: isEdition => ({
		type: actionTypes.INTERACTIVE_VIDEO_CREATION_OEQ_SAVE_SUCCESS,
		isEdition,
	}),
}

export default iVideoCreationOeqActions
